<template>
  <div>
    <h4>Users View</h4>
    <div>
      <vs-table max-items="10" search pagination :data="users">
        <template slot="thead">
          <vs-th sort-key="ref">ID</vs-th>
          <vs-th sort-key="first_name">First Name</vs-th>
          <vs-th sort-key="last_name">Last Name</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="role">role</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :id="indextr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].ref">
              {{ data[indextr].ref }}
            </vs-td>

            <vs-td :data="data[indextr].first_name">
              {{ data[indextr].first_name }}
            </vs-td>

            <vs-td :data="data[indextr].last_name">
              {{ data[indextr].last_name }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>
            <vs-td :data="data[indextr].role">
              {{ data[indextr].role }}
            </vs-td>

            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full">
                <div class="con-btns-user flex items-center justify-between">
                  <div class="con-userx flex items-center justify-start">
                    <vs-avatar :badge="tr.id" size="45px" :src="tr.image" />
                    <span :id="tr.image"
                      >{{ tr.first_name }} {{ tr.last_name }}</span
                    >
                  </div>
                  <div class="flex">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="mr-2"
                      @click="viewDetails(tr._id)"
                    >
                    </vs-button>

                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="mr-2"
                    ></vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                    ></vs-button>
                  </div>
                </div>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    users() {
      return this.$store.getters.getUserList;
    },
  },
  methods: {},
  async beforeMount() {
    await this.$store.dispatch("USERSLIST_REQUEST");
  },
};
</script>
